import React, { useState } from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { Inertia } from '@inertiajs/inertia'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import PaginationList from '../../../Shared/Components/PaginationList'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

const BooksIndex = ({ books, filters }) => {
    const { flash } = usePage().props
    const data = books.data
    const [deleteTarget, setDeleteTarget] = useState(null)
    const [deleting, setDeleting] = useState(false)

    const filterForm = useForm({
        search: filters.search || '',
    })

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route('sia.manage.libros.index'), { preserveState: true })
    }

    const clearFilters = () => {
        filterForm.setData({ search: '' })
        filterForm.get(route('sia.manage.libros.index'))
    }

    const paginationFilters = {
        search: filters.search || undefined,
    }

    const listPath = 'admin/sia/manage/libros'

    const confirmDelete = () => {
        if (!deleteTarget) return
        setDeleting(true)
        Inertia.delete(route('sia.manage.libros.destroy', deleteTarget.id), {
            preserveScroll: true,
            onFinish: () => {
                setDeleting(false)
                setDeleteTarget(null)
            },
        })
    }

    return (
        <Row>
            {flash.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath={listPath} />
            </span>

            <div className="card card-flush h-md-100">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">Libros (SIA)</span>
                    </h3>
                    <div className="card-toolbar">
                        <Link href={route('sia.manage.libros.create')} className="btn btn-sm btn-primary">
                            Agregar libro
                        </Link>
                    </div>
                </div>

                <div className="card-body pt-6">
                    <Form onSubmit={submitFilters} className="d-flex flex-wrap align-items-end gap-3 mb-8">
                        <div className="flex-grow-1" style={{ minWidth: '220px', maxWidth: '420px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Buscar</label>
                            <Form.Control
                                type="search"
                                className="form-control form-control-sm form-control-solid"
                                placeholder="Título…"
                                value={filterForm.data.search}
                                onChange={(e) => filterForm.setData('search', e.target.value)}
                            />
                        </div>
                        <Button type="submit" size="sm" variant="primary" disabled={filterForm.processing}>
                            Buscar
                        </Button>
                        <Button type="button" size="sm" variant="light" onClick={clearFilters}>
                            Limpiar
                        </Button>
                    </Form>

                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                    <th className="p-0 pb-3 min-w-50px text-start">ID</th>
                                    <th className="p-0 pb-3 min-w-250px text-start">Título</th>
                                    <th className="p-0 pb-3 min-w-75px text-start">Orden</th>
                                    <th className="p-0 pb-3 min-w-100px text-start">Portada</th>
                                    <th className="p-0 pb-3 min-w-100px text-start">PDF</th>
                                    <th className="p-0 pb-3 min-w-125px text-end">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 && (
                                    <tr>
                                        <td className="text-center py-10 text-gray-700" colSpan={6}>
                                            No hay libros registrados.
                                        </td>
                                    </tr>
                                )}
                                {data.map((row) => (
                                    <tr key={row.id}>
                                        <td className="text-gray-800">{row.id}</td>
                                        <td className="text-gray-900 fw-semibold">{row.title}</td>
                                        <td>{row.sort_order}</td>
                                        <td>{row.cover_path ? 'Sí' : '—'}</td>
                                        <td>{row.file_path ? 'Sí' : '—'}</td>
                                        <td className="text-end">
                                            <Link href={route('sia.manage.libros.edit', row.id)} className="btn btn-sm btn-light-primary me-2">
                                                Editar
                                            </Link>
                                            <button type="button" className="btn btn-sm btn-light-danger" onClick={() => setDeleteTarget(row)}>
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-center py-6">
                        <PaginationList links={books.links} filters={paginationFilters} />
                    </div>
                </div>
            </div>

            <Modal show={deleteTarget !== null} onHide={() => !deleting && setDeleteTarget(null)} centered>
                <Modal.Header closeButton={!deleting}>
                    <Modal.Title>Confirmar eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Eliminar el libro «{deleteTarget?.title}»? Se borrarán también los archivos en servidor.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" disabled={deleting} onClick={() => setDeleteTarget(null)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" disabled={deleting} onClick={confirmDelete}>
                        {deleting ? 'Eliminando…' : 'Eliminar'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Row>
    )
}

BooksIndex.layout = (page) => <Layout title="Libros SIA">{page}</Layout>

export default BooksIndex
